import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export type ToastKind = 'success' | 'error' | 'info' | 'warning';

export interface ToastData {
  /** Main headline shown large. */
  title: string;
  /** Optional secondary line shown below the title, smaller. */
  description?: string;
  /** Drives the icon and the accent color stripe. */
  kind: ToastKind;
  /** Optional Material Symbols icon name to override the default per kind. */
  icon?: string;
}

/**
 * Rich toast displayed via MatSnackBar.openFromComponent. Rendered
 * significantly bigger than the default MDC snackbar so older users
 * can read it easily, with room for a description line, a coloured
 * accent stripe on the right, an icon, and a close button.
 */
@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: ToastData,
    private ref: MatSnackBarRef<ToastComponent>,
  ) {}

  get iconName(): string {
    if (this.data.icon) return this.data.icon;
    switch (this.data.kind) {
      case 'success': return 'check_circle';
      case 'error':   return 'error';
      case 'warning': return 'warning';
      default:        return 'info';
    }
  }

  close(): void {
    this.ref.dismiss();
  }
}
